module.exports = __webpack_public_path__ + "img/ez-slot-category-new-released-hover.13e9d859.png";